import React from 'react';
import { ButtonCardGroup, ButtonItem } from '../ButtonCardGroup';

interface ButtonStepInterface {
  title: string;
  customClass: string;
  onclick: (string) => void;
  options: ButtonItem[];
  notes?: string;
}

export const ButtonStep: React.FC<ButtonStepInterface> = ({ customClass, notes, onclick, options, title }) => {
  return (
    <section className={`step ${customClass}`}>
      <h2 className="section-h2">{title}</h2>
      <div className="section-container">
        <ButtonCardGroup buttons={options} onClick={onclick} />
        {notes && <div className="notes">{notes}</div>}
      </div>
    </section>
  );
};
